var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});



// WEBPACK FOOTER //
// ./node_modules/core-js/modules/web.immediate.js